import React, { useEffect } from 'react';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import CloseIcon from '@mui/icons-material/Close';

export interface AlertMessageProps {
  type?: 'success' | 'error' | 'warning' | 'info';
  message: string;
  hideAfterSec?: number;
  onClose?: () => void;
}

const AlertMessage: React.FC<AlertMessageProps> = ({ type = 'success', message, hideAfterSec = 10, onClose = () => {}}) => {
  useEffect(() => {
    const timeout = setTimeout(() => {
      if (onClose) {
        onClose(); // Automatically close the message after hideAfterSec seconds
      }
    }, hideAfterSec * 1000);

    return () => clearTimeout(timeout); // Clean up the timeout on component unmount
  }, [hideAfterSec, onClose]);

  return (
    <Alert
      severity={type}
      variant='filled'
      style={{
        position: 'fixed',
        bottom: '20px',
        left: 0,
        width: '50%',
        zIndex: 9999,
        right:0,
        margin: 'auto'
      }}
      action={
        <CloseIcon
          fontSize="large"
          style={{ cursor: 'pointer' }}
          onClick={onClose}
        />
      }
    >
      <AlertTitle>{type === 'success' ? 'Success' : 'Error'}</AlertTitle>
      {message}
    </Alert>
  );
};

export default AlertMessage;
